'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  box-sizing: border-box;\n  z-index: 1400;\n  top: 0px;\n  left: ', ';\n  width: 100%;\n  height: 100%;\n  transition: left 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n'], ['\n  position: fixed;\n  box-sizing: border-box;\n  z-index: 1400;\n  top: 0px;\n  left: ', ';\n  width: 100%;\n  height: 100%;\n  transition: left 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  bottom: 0;\n  opacity: ', ';\n  left: ', ';\n  transition: left 0ms cubic-bezier(0.4,0,0.2,1) 0ms, opacity 500ms cubic-bezier(0.4,0,0.2,1) 0ms;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1400;\n  pointer-events: auto;\n'], ['\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  bottom: 0;\n  opacity: ', ';\n  left: ', ';\n  transition: left 0ms cubic-bezier(0.4,0,0.2,1) 0ms, opacity 500ms cubic-bezier(0.4,0,0.2,1) 0ms;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1400;\n  pointer-events: auto;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 80%;\n  max-width: 768px;\n  margin: 0px auto;\n  z-index: 1500;\n  opacity: ', ';\n  transform: translate(-50%, -50%);\n  max-height: 100%;\n  overflow-y: auto;\n\n  padding: 24px;\n\n  background-color: rgb(255, 255, 255);\n  box-sizing: border-box;\n  font-family: noto-sans-regular;\n  box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 45px, rgba(0, 0, 0, 0.22) 0px 10px 18px;\n  border-radius: 2px;\n  transition: all 500ms cubic-bezier(0.4,0,0.2,1) 0ms;\n\n  @media(max-width: 480px) {\n    width: 100%;\n  }\n'], ['\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 80%;\n  max-width: 768px;\n  margin: 0px auto;\n  z-index: 1500;\n  opacity: ', ';\n  transform: translate(-50%, -50%);\n  max-height: 100%;\n  overflow-y: auto;\n\n  padding: 24px;\n\n  background-color: rgb(255, 255, 255);\n  box-sizing: border-box;\n  font-family: noto-sans-regular;\n  box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 45px, rgba(0, 0, 0, 0.22) 0px 10px 18px;\n  border-radius: 2px;\n  transition: all 500ms cubic-bezier(0.4,0,0.2,1) 0ms;\n\n  @media(max-width: 480px) {\n    width: 100%;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  padding: 20px ', 'px;\n  @media(max-width: 1024px) {\n    padding: 20px 0;\n  }\n'], ['\n  padding: 20px ', 'px;\n  @media(max-width: 1024px) {\n    padding: 20px 0;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  align-items: center;\n  display: flex;\n  flex-flow: column wrap;\n  justify-content: center;\n  font-size: 14px;\n  margin-bottom: 40px;\n'], ['\n  align-items: center;\n  display: flex;\n  flex-flow: column wrap;\n  justify-content: center;\n  font-size: 14px;\n  margin-bottom: 40px;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n\n'], ['\n\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _nitroHeading = require('../nitro-heading');

var _nitroHeading2 = _interopRequireDefault(_nitroHeading);

var _nitroButton = require('../nitro-button');

var _nitroButton2 = _interopRequireDefault(_nitroButton);

var _nitroDivider = require('../nitro-divider');

var _nitroDivider2 = _interopRequireDefault(_nitroDivider);

var _nitroButtonGroup = require('../nitro-button-group');

var _nitroButtonGroup2 = _interopRequireDefault(_nitroButtonGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Dialog = _styledComponents2.default.section(_templateObject, function (props) {
  return props.open ? '0' : '-100%';
});

Dialog.displayName = 'Dialog';
var Background = _styledComponents2.default.div(_templateObject2, function (props) {
  return props.open ? 1 : 0;
}, function (props) {
  return props.open ? '0' : '-100%';
});

Background.displayName = 'Background';
var DialogContainer = _styledComponents2.default.div(_templateObject3, function (props) {
  return props.open ? 1 : 0;
});

DialogContainer.displayName = 'DialogContainer';
var DialogContent = _styledComponents2.default.div(_templateObject4, function (props) {
  return props.padding;
});
DialogContent.displayName = 'DialogContent';
DialogContent.defaultProps = {
  padding: 60
};

var DialogMessage = _styledComponents2.default.div(_templateObject5);

DialogMessage.displayName = 'DialogMessage';
var ButtonContainer = _styledComponents2.default.div(_templateObject6);

ButtonContainer.displayName = 'ButtonContainer';

var NitroModal = function (_Component) {
  _inherits(NitroModal, _Component);

  function NitroModal() {
    _classCallCheck(this, NitroModal);

    return _possibleConstructorReturn(this, (NitroModal.__proto__ || Object.getPrototypeOf(NitroModal)).apply(this, arguments));
  }

  _createClass(NitroModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.isOpen) {
        document.body.style.overflow = 'hidden';
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      if (nextProps.isOpen !== this.props.isOpen) {
        if (nextProps.isOpen) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = 'auto';
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.body.style.overflow = 'auto';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$variant = _props.variant,
          variant = _props$variant === undefined ? 'primary' : _props$variant,
          className = _props.className,
          isOpen = _props.isOpen,
          close = _props.close,
          title = _props.title,
          children = _props.children,
          padding = _props.padding,
          isLoading = _props.isLoading,
          disabled = _props.disabled,
          action = _props.action,
          _props$actionLabel = _props.actionLabel,
          actionLabel = _props$actionLabel === undefined ? 'Confirm' : _props$actionLabel,
          _props$cancelLabel = _props.cancelLabel,
          cancelLabel = _props$cancelLabel === undefined ? 'Cancel' : _props$cancelLabel,
          extraAction = _props.extraAction,
          _props$extraLabel = _props.extraLabel,
          extraLabel = _props$extraLabel === undefined ? 'Remove' : _props$extraLabel,
          _props$actionMaxWidth = _props.actionMaxWidth,
          actionMaxWidth = _props$actionMaxWidth === undefined ? 350 : _props$actionMaxWidth,
          _props$headingVariant = _props.headingVariant,
          headingVariant = _props$headingVariant === undefined ? 'secondary' : _props$headingVariant,
          _props$buttonLayout = _props.buttonLayout,
          buttonLayout = _props$buttonLayout === undefined ? 'horizontal' : _props$buttonLayout;


      var actionGroup = _react2.default.createElement(
        ButtonContainer,
        null,
        _react2.default.createElement(
          _nitroButtonGroup2.default,
          { layout: buttonLayout, align: 'center', maxWidth: actionMaxWidth },
          extraAction && _react2.default.createElement(_nitroButton2.default, { label: extraLabel, action: extraAction, size: 'small', block: true }),
          _react2.default.createElement(_nitroButton2.default, { label: cancelLabel, action: close, size: 'small', block: true }),
          _react2.default.createElement(_nitroButton2.default, {
            disabled: disabled,
            loading: isLoading,
            label: actionLabel,
            variant: variant,
            action: action,
            size: 'small',
            block: true
          })
        )
      );

      return _react2.default.createElement(
        Dialog,
        { className: className, open: isOpen },
        _react2.default.createElement(Background, { open: isOpen }),
        _react2.default.createElement(
          DialogContainer,
          { open: isOpen },
          _react2.default.createElement(
            DialogContent,
            { padding: padding },
            title && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_nitroHeading2.default, { label: title, size: '1', align: 'center', variant: headingVariant, noMargin: true }),
              _react2.default.createElement(_nitroDivider2.default, { sidePanel: true })
            ),
            _react2.default.createElement(
              DialogMessage,
              null,
              children
            ),
            actionGroup
          )
        )
      );
    }
  }]);

  return NitroModal;
}(_react.Component);

NitroModal.propTypes = {
  variant: _propTypes2.default.string,
  isLoading: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  close: _propTypes2.default.func.isRequired,
  action: _propTypes2.default.func.isRequired,
  isOpen: _propTypes2.default.bool.isRequired,
  title: _propTypes2.default.string,
  children: _propTypes2.default.node,
  actionLabel: _propTypes2.default.string,
  cancelLabel: _propTypes2.default.string,
  cancelAction: _propTypes2.default.func,
  extraAction: _propTypes2.default.func,
  extraLabel: _propTypes2.default.string,
  actionMaxWidth: _propTypes2.default.number,
  padding: _propTypes2.default.number,
  buttonLayout: _propTypes2.default.string,
  headingVariant: _propTypes2.default.string,
  className: _propTypes2.default.string
};

exports.default = NitroModal;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-modal/NitroModal.js
// module id = 3017
// module chunks = 4